import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { IMainIndicatorsFilter } from 'pages/Main/components/Filter';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { IBoeingLineAccounts } from '@entities/boeing/IBoeingLineAccounts';
import { buildDateParams } from '@app/utils/buildDateParams';

export const fetch = async (filters: IMainIndicatorsFilter): Promise<IBoeingLineAccounts[]> => {
  const params = buildDateParams(filters);

  const response = await api.get<{
    data: { reward: string; date: string }[];
  }>(`${BI_BASE_URL}/boeing/line/left/accounts`, {
    params: {
      manager_ids: filters.managers,
      region: filters.regions,
      tag: filters.tags,
      source: filters.sources,
      coins: filters.coins,
      ...params,
    },
  });

  const data = response.data ?? [];

  // @ts-ignore
  return data.map(
    (item: {
      date: string;
      left_hashrate: number;
      left_clients: number;
      left_accounts: number;
    }) => ({
      date: item.date,
      hashrate: item.left_hashrate,
      accounts: item.left_accounts,
      clients: item.left_clients,
    })
  );
};

export const useBoeingLineLeftAccounts = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
